import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './style.module.css';

const PriceFilters = forwardRef(({ onPriceRangeChange }, ref) => {
  const containerRef = useRef(null);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);

  const priceRanges = [
    { minPrice: null, maxPrice: null, label: 'Hamısı' },
    { minPrice: 1, maxPrice: 10, label: '1-10 ₼' },
    { minPrice: 10, maxPrice: 50, label: '10-50 ₼' },
    { minPrice: 50, maxPrice: 100, label: '50-100 ₼' },
    { minPrice: 100, maxPrice: null, label: '100+ ₼' }
  ];

  // Expose the selectedPriceRange and reset method through the ref
  useImperativeHandle(ref, () => ({
    selectedPriceRange,
    resetPriceRange: () => {
      const allPricesRange = priceRanges[0]; // "Hamısı" option
      setSelectedPriceRange(allPricesRange);
      if (onPriceRangeChange) {
        onPriceRangeChange(allPricesRange);
      }
    }
  }));

  // Set initial selection to "All"
  useEffect(() => {
    const initialRange = priceRanges[0];
    setSelectedPriceRange(initialRange);
  }, []);

  // Update local state when price range changes
  const handlePriceRangeSelect = (range) => {
    setSelectedPriceRange(range);
    if (onPriceRangeChange) {
      onPriceRangeChange(range);
    }
  };

  return (
    <div className={styles.priceRangesContainer}>
      <div
        ref={containerRef}
        className={styles.scrollableContainer}
      >
        <ButtonGroup className={styles.priceRangesButtonGroup}>
          {priceRanges.map((range) => {
            const isSelected = selectedPriceRange && 
                selectedPriceRange.minPrice === range.minPrice && 
                selectedPriceRange.maxPrice === range.maxPrice;
            
            return (
              <Button
                key={`${range.minPrice}-${range.maxPrice}`}
                variant="outline-secondary"
                className={`${styles.priceChip} ${isSelected ? styles.selected : ''}`}
                onClick={() => handlePriceRangeSelect(range)}
              >
                <span className={styles.priceChipText}>{range.label}</span>
              </Button>
            );
          })}
        </ButtonGroup>
      </div>
    </div>
  );
});

export default PriceFilters;